import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import DraggableItemTypes from './DraggableItemsTypes';

const itemSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index
    };
  }
};

const itemTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    // Time to actually perform the action
    props.moveItem(dragIndex, hoverIndex);

    // mutating the monitor item. it's good here
    // for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  }
};

@DropTarget(DraggableItemTypes.ITEM, itemTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver()
}))

@DragSource(DraggableItemTypes.ITEM, itemSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
}))

export class SimpleReactSortableComponent extends Component {
  static propTypes = {
    node: React.PropTypes.object.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    isDragging: PropTypes.bool.isRequired,
    isOver: PropTypes.bool.isRequired,
    id: PropTypes.any.isRequired,
    moveItem: PropTypes.func.isRequired,
    renderOverlay: PropTypes.func.isRequired,
    children: React.PropTypes.node.isRequired
  };

  render() {
    let {connectDropTarget} = this.props;
    let draggableProps = {
      node: this.props.node,
      index: this.props.index,
      connectDragSource: this.props.connectDragSource,
      connectDragPreview: this.props.connectDragPreview,
      isDragging: this.props.isDragging,
      isOver: this.props.isOver,
      moveItem: this.props.moveItem,
      renderOverlay: this.props.renderOverlay
    };

    return connectDropTarget(
      <div style={{position: 'relative', height: '100%'}}>
        {React.cloneElement(this.props.children, draggableProps)}
        {draggableProps.isOver && draggableProps.renderOverlay()}
      </div>
    );
  }
}

export default SimpleReactSortableComponent;




// WEBPACK FOOTER //
// ./src/components/ClubCMS/DragItems/DraggableItem/SimpleReactSortableComponent.js